var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Feature } from 'ol';
import { bbox } from 'ol/loadingstrategy';
import { fromExtent } from 'ol/geom/Polygon';
import VectorSource from 'ol/source/Vector';
import { getGeometries } from '../services/layerService';
import { toPolygon } from './convertBetweenPolygonElement';
import createPopupHTML from './createPopupHTML';
export var createVectorSource = function (tableName, parentIdKey, parentExtents, labelKeys, labelClass) {
    var source = new VectorSource({
        loader: function (extent) { return __awaiter(void 0, void 0, void 0, function () {
            var extentPolygon, response, loaded;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        extentPolygon = fromExtent(extent);
                        return [4 /*yield*/, getGeometries(tableName, extentPolygon)];
                    case 1:
                        response = (_a.sent()) || [];
                        loaded = source
                            .getFeatures()
                            .map(function (f) { var _a; return (_a = f.getGeometry()) === null || _a === void 0 ? void 0 : _a.get('element').id; });
                        if (response.length > 0) {
                            // Add polygons to the layersource
                            response.forEach(function (element) {
                                var itemGeometry = element.geom;
                                // Set a property for the extent of parent to use it for controlling zoomToExtent button
                                var parentId = element[parentIdKey];
                                var parentExtent = parentExtents[parentId];
                                // Add feature to source, if the feature has not been added yet
                                if (!loaded.includes(element.id)) {
                                    var feature = new Feature({
                                        geometry: toPolygon({
                                            geom: itemGeometry,
                                            element: __assign(__assign({}, element), { itemGeometry: itemGeometry, tableName: tableName, parentExtent: parentExtent, popupHTML: createPopupHTML(element, element.fancyName, labelKeys, labelClass) }),
                                        }),
                                    });
                                    source.addFeature(feature);
                                }
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        strategy: bbox,
    });
    return source;
};
